import log from 'loglevel';
import remote from 'loglevel-plugin-remote';
import CONFIG from '../config';
import { getDeviceInfo } from './authentication';

export const initLogLevel = async () => {
  const options = {
    backoff: {
      multiplier: 5,
      jitter: 0.1,
      limit: 30000,
    },
    capacity: 1,
  };

  const errorJSON = (log, type) => {
    let stringifiedMsg = JSON.stringify(log.message);
    // console.log('message:', JSON.parse(stringifiedMsg));

    return {
      msg: log.message,
      level: JSON.parse(stringifiedMsg).customLevel || log.level.label,
      stacktrace: log.stacktrace,
    };
  };

  remote.apply(log, { format: errorJSON, url: `${CONFIG.logsDomain}/errorLogs`, ...options });
  log.enableAll();
};

export const sendErrorReport = (error, info, username) => {
  const deviceInfo = getDeviceInfo();

  import('stacktrace-js').then((StackTrace) =>
    StackTrace.fromError(error).then((err) => {
      StackTrace.report(err, `${CONFIG.logsDomain}/errorLogs`, {
        url: window.location.href,
        userId: username,
        agent: window.navigator.userAgent,
        date: new Date(),
        ...deviceInfo,
        msg: error.toString(),
      });
    })
  );
};
